import { useState, cloneElement } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { classNames } from '../../utils/classNames';
import {
    extraNavigation,
} from '../../utils/navigation-constants/navigation-partner';
import Button from '../../shared/button';
import { useGetBrandingConfigQuery, useTopicsListQuery } from '../../store/chatbox/chatboxApi';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import { removeFromStorage } from '../../utils/webStorage';
import ThemeToggle from '../../shared/theme-toggle';
import { useTheme } from '../../utils/theme-context';
import Cookies from 'js-cookie';
import { DOMAIN } from '../../config';

interface INavigation {
    search?: string
    closeSidebar?: () => void
}

const Navigation = ({
    search,
    closeSidebar
}: INavigation) => {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const [activeRoute] = useState<string>()
    const [navigationPartnerExtra] = useState<any>(extraNavigation)
    const [loading] = useState<boolean>(false)

    const { data: userInfo } = useGetCurrentUserQuery();
	const {data: brand} = useGetBrandingConfigQuery(userInfo?.hotelInfo.username || '', {
		skip: !userInfo?.id
	});
    const { data: historyChats } = useTopicsListQuery({ type: 'TOPIC', userId: userInfo?.id || '', page: 1, limit: 10 }, {
        skip: !userInfo?.id
    });

    const onClickNewChat = () => {
        closeSidebar?.()
        navigate('/home?newChat=true')
    }

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        removeFromStorage('accessToken');
        removeFromStorage('refreshToken');
        removeFromStorage('roles');
        removeFromStorage('user');
		localStorage.setItem('authText', 'used it before');
		Cookies.remove('accessToken', {
			domain: DOMAIN,
			path: '/',
		})
		Cookies.remove('refreshToken', {
			domain: DOMAIN,
			path: '/',
		})
		Cookies.remove('roles', {
			domain: DOMAIN,
			path: '/',
		})
		Cookies.remove('user')
        // window.location.reload();
        // (window as any).Intercom('shutdown');
        navigate('/auth');
    }

    return (
        <div className='flex flex-col min-h-[90vh] justify-between '>
            <>
                <div className=''>
                    <p className='mb-3 text-[#8a8a8e] text-[13px]'>History</p>
                    <Button
                        label={'New chat'}
                        onClickButton={onClickNewChat}
                        className='btn-primary-rounded dark:!bg-white w-full flex flex-row justify-center items-center !text-normal !py-3 mb-5'
						style={(process.env.REACT_APP_PROJECT !== 'nynn' && brand?.metadata.ctaButtonColor) ? {backgroundColor: brand?.metadata.ctaButtonColor } : {}}
                        icon={<img src={theme === 'dark' ? '/assets/chat/add.svg' : '/assets/chat/add-white.svg'} className='object-contain mr-2 w-[20px]' />}
                    />
                    {historyChats && historyChats.elements?.length > 0 && historyChats.elements?.map(item => (
                        <NavLink
                            key={item._id}
                            onClick={closeSidebar}
                            className='w-full mb-2 flex flex-row items-center border border-gray-100 dark:border-[#171717] text-gray-900 text-sm p-2 cursor-pointer'
                            to={`/chat/${item._id}`}
                        >
                            <img alt='chat' className='mr-2 object-contain w-[20px]' src={theme === 'dark' ? '/svg/icons/chat-icon-white.svg' :'/svg/icons/chat.svg'} />
                            <p className='truncate dark:text-primary-darkMode'>{item?.name}</p>
                        </NavLink>
                    )
                    )}
                </div>
                <div className='mb-1 border-t-[1px] pt-2 dark:border-black'>
                    <p className='mb-3 text-[#8a8a8e] text-[13px]'>Profile</p>
                    {!loading && navigationPartnerExtra?.map((item: any) => (
                        item.href ? <NavLink
                            key={item.name}
                            to={item.href}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            onClick={item.id === 'logout' ? handleLogout : closeSidebar}
                            className={({ isActive }) =>
                                classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2',
                                    theme === 'dark'
                                        ? '!text-primary-darkMode'
                                        : '',
                                )
                            }
                        >
                            {/* <item.icon className='mr-3 flex-shrink-0 h-6 w-6 text-indigo-300' aria-hidden='true' /> */}
                            <span className='flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'>
                                {activeRoute === item?.href ?
                                    cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                    : cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                }
                            </span>
                            {item.name}
                        </NavLink> : <div
                            key={item.name}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            onClick={item.id === 'logout' ? handleLogout : closeSidebar}
                            className={classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2 cursor-pointer',
                                    theme === 'dark'
                                        ? '!text-primary-darkMode'
                                        : '',
                                )
                            }
                        >
                            <span className='flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'>
                                {cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })}
                            </span>
                            {item.name}
                        </div>
                    ))}
					<div className='my-4 sm:mt-12'>
                        <ThemeToggle />
                    </div>
                </div>
            </>

        </div>
    );
};

export default Navigation;